<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  props: ['chartData', 'options'],
  data() {
    return {
      defaultOptions: {
        responsive: true, // my new default options
        maintainAspectRatio: false, // my new default options
        scales: {
          scaleLabels: {},
          yAxes: [
            {
              ticks: {
                callback: function(value, index, values) {
                  return value + ' €';
                },
                beginAtZero: true,
                fontStyle: 'bold',
              },
              gridLines: {
                display: true, // my new default options
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontStyle: 'bold',
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    if (this.options) {
      this.defaultOptions = this.options;
    }
    this.renderChart(this.chartData, this.defaultOptions);
  },
  // watch: {
  //     chartData: {
  //         handler: function(val, oldVal) {
  //             this.renderChart(this.chartData, this.defaultOptions)
  //         },
  //         deep: true
  //     }
  // }
};
</script>
